import React from 'react';

export const MenuItemSeparator = () => (
  <li className='kt-menu__separator'>
    <span />
  </li>
);
